// Company Configuration
// This file contains all company-related information that can be easily updated
// Update these values according to your company details

import { CompanyConfig } from '@/models/config';

// Default company configuration
// Update these values with your actual company information
export const COMPANY_CONFIG: CompanyConfig = {
  name: 'Regal Engineers',
  address: 'J-17 Swastik Industrial Estate',
  city: 'Bhayander East',
  state: 'Maharashtra',
  pinCode: '401105',
  country: 'India',
  mobile: '+91 9768802331, +91 7666412328',
  email: 'regalengineers@ymail.com',
  gstin: '27AIFPP6768D1ZX',
  pan: 'AIFPP6768D',
  termsAndConditions: `
    1. Payment is due within 30 days of invoice date
    2. Late payments may incur additional charges
    3. Goods once sold will not be taken back
    4. All disputes are subject to Mumbai jurisdiction
  `,
  paymentTerms: 'Net 30 days'
};

// Helper function to get formatted address
export const getFormattedAddress = (): string => {
  const { address, city, state, pinCode, country } = COMPANY_CONFIG;
  return `${address}, ${city}, ${state} ${pinCode}, ${country}`;
};

// Helper function to get contact information
export const getContactInfo = (): string => {
  const { mobile, email } = COMPANY_CONFIG;
  return `Mobile: ${mobile} | Email: ${email}`;
};

// Helper function to get tax information
export const getTaxInfo = (): string => {
  const { gstin, pan } = COMPANY_CONFIG;
  return `GSTIN: ${gstin} | PAN: ${pan}`;
};

// Export default configuration
export default COMPANY_CONFIG; 